import { Company } from "../../../../interfaces/Company";
import { Project } from "../../../../interfaces/Project";
import { Status } from "../../../../interfaces/Status";
import React, { useState } from "react";
import api from "../../../../services/axios";

import { toast } from "react-toastify";
import { PatchStatusTimeSheet } from "../../../../interfaces/UpdateHoursDetail";

interface EditStatusModalProps {
  isModalOpen: boolean;
  month: number | undefined;
  initialProjectValue: number;
  project: Project[];
  initialCompanyValue: number;
  company: Company[];
  status: Status[];
  initialStatusValue: number;
  timeSheetId: number;
  onClose: () => void;
  onUpdate: () => void;
}

const EditStatusModal: React.FC<EditStatusModalProps> = ({
  isModalOpen,
  month,
  initialProjectValue,
  initialCompanyValue,
  project,
  company,
  status,
  timeSheetId,
  initialStatusValue,
  onClose,
  onUpdate,
}) => {
  const toggleModal = () => {
    onClose();
  };

  const [selectedStatus, setSelectedStatus] =
    useState<number>(initialStatusValue);
  const [selectedCompany, setSelectedCompany] =
    useState<number>(initialCompanyValue);
  const [selectedProject, setSelectedProject] =
    useState<number>(initialProjectValue);

  const [onDelete, setDelete] = useState(false);

  const handleOnSave = () => {
    setDelete(true);
  };

  const handleStatusChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedStatus(Number(event.target.value));
  };

  const handleCompanyChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCompany(Number(event.target.value));
  };

  const handleProjectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedProject(Number(event.target.value));
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const payload: PatchStatusTimeSheet = {
      timeSheetId: timeSheetId,
      status: selectedStatus,
    };

    if (onDelete === true) {
      patchStatusTimeSheet(payload);
      onClose();
      onSearchUpdate();
    } else {
      onClose();
      onSearchUpdate();
    }
  };

  if (!isModalOpen) {
    return null;
  }

  async function patchStatusTimeSheet(status: PatchStatusTimeSheet) {
    try {
      const response = await api.patch(
        `/TimeManagement/ChangeStatus?timesheetId=${status.timeSheetId}&status=${status.status}`
      );

      // console.log(JSON.stringify(status));

      if (response.status !== 200) {
        let errorMessage =
          response.data.message || JSON.stringify(response.data);
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

      toast.success("Success to update Status", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      return response.data;
    } catch (error) {
      console.error("Error updating worked status:", error);
      toast.error("Error updating worked status", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  const onSearchUpdate = () => {
    onUpdate();
  };

  const fieldCls =
    "w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 transition-all focus:border-dv-blue-500 focus:outline-none focus:ring-2 focus:ring-dv-blue-500/20 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/10 dark:bg-navy-900 dark:text-white";
  const labelCls = "mb-1.5 block text-sm font-semibold text-gray-700 dark:text-gray-300";

  return (
    <>
      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-ink-900/60 p-4 backdrop-blur-sm"
        onClick={toggleModal}
      >
        <div
          className="relative max-h-[90vh] w-full max-w-md overflow-y-auto rounded-2xl bg-white nina-surface shadow-dv-lg dark:bg-navy-800"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4 dark:border-white/10">
            <h3 className="text-lg font-bold text-navy-700 dark:text-white">
              Alterar status
            </h3>
            <button
              type="button"
              aria-label="Fechar"
              className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-gray-500 transition-colors hover:bg-gray-100 hover:text-navy-700 dark:text-gray-400 dark:hover:bg-navy-700 dark:hover:text-white"
              onClick={toggleModal}
            >
              <svg
                className="h-3.5 w-3.5"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
                aria-hidden="true"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
            </button>
          </div>
          <div className="px-6 py-5">
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="status-client" className={labelCls}>
                  Cliente
                </label>
                <select
                  id="status-client"
                  value={selectedCompany}
                  onChange={handleCompanyChange}
                  className={fieldCls}
                  disabled
                >
                  <option value="">Selecione…</option>
                  {company.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.legalName}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label htmlFor="status-project" className={labelCls}>
                  Projeto
                </label>
                <select
                  id="status-project"
                  value={selectedProject}
                  onChange={handleProjectChange}
                  className={fieldCls}
                  disabled
                >
                  <option value="">Selecione…</option>
                  {project.map((option) => (
                    <option key={option.projectId} value={option.projectId}>
                      {option.nmProject}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label htmlFor="month" className={labelCls}>
                  Mês
                </label>
                <select
                  className={fieldCls}
                  id="month"
                  defaultValue={month}
                  disabled
                >
                  <option value={1}>Janeiro</option>
                  <option value={2}>Fevereiro</option>
                  <option value={3}>Março</option>
                  <option value={4}>Abril</option>
                  <option value={5}>Maio</option>
                  <option value={6}>Junho</option>
                  <option value={7}>Julho</option>
                  <option value={8}>Agosto</option>
                  <option value={9}>Setembro</option>
                  <option value={10}>Outubro</option>
                  <option value={11}>Novembro</option>
                  <option value={12}>Dezembro</option>
                </select>
              </div>
              <div>
                <label htmlFor="status-select" className={labelCls}>
                  Status <span className="text-dv-magenta-600">*</span>
                </label>
                <select
                  id="status-select"
                  value={selectedStatus}
                  onChange={handleStatusChange}
                  className={fieldCls}
                  required
                >
                  <option value="">Selecione…</option>
                  {status.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="pt-1">
                <button
                  type="submit"
                  className="flex w-full items-center justify-center gap-2 rounded-xl bg-ink-900 px-5 py-2.5 text-sm font-bold text-white shadow-dv-md transition-all hover:bg-ink-800 active:scale-[.98] disabled:cursor-not-allowed disabled:opacity-50 dark:bg-white dark:text-ink-900 dark:hover:bg-gray-100"
                  name="save"
                  onClick={handleOnSave}
                  disabled={selectedStatus === 0}
                >
                  Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditStatusModal;
